import React from 'react';

import usePortfoliosFilterController from '../controllers/PortfoliosFilterController';

type PortfolioLifetime = 'active' | 'planned' | 'completed';

interface PortfoliosFilterContextValue {
  order: {
    value: {
      orderBySuccessRate: string | null | undefined;
      orderByTitle: string | null | undefined;
    };
    setOrder: React.Dispatch<
      React.SetStateAction<{
        orderBySuccessRate: string | null | undefined;
        orderByTitle: string | null | undefined;
      }>
    >;
  };
  search: {
    value: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
  };
  lifetime: {
    value: PortfolioLifetime;
    setLifetime: (nextLifetime: PortfolioLifetime) => void;
  };
}

const PortfoliosFilterContext = React.createContext<PortfoliosFilterContextValue | null>(null);

function PortfoliosFilterProvider(props: any) {
  const value = usePortfoliosFilterController();
  return <PortfoliosFilterContext.Provider value={value} {...props} />;
}

function withPortfolioFilterProvider(Component: any) {
  return (props: any) => (
    <PortfoliosFilterProvider>
      <Component {...props} />
    </PortfoliosFilterProvider>
  );
}

function usePortfoliosFilter(): PortfoliosFilterContextValue {
  const context = React.useContext(PortfoliosFilterContext);

  if (context === undefined) {
    throw new Error('usePortfoliosFilter must be used within a PortfoliosFilterProvider');
  }

  return context;
}

export { PortfoliosFilterProvider, usePortfoliosFilter, withPortfolioFilterProvider };
